import React from "react";
import NoAccess from "../../pages/NoAccess/NoAccess";


const NoAccessRoute = {
  path: "*",
  element: <NoAccess />,
};
export default NoAccessRoute;
